<a
  href="{{ mailLink }}"
  class="text-white font-medium rounded-lg text-sm px-4 xl:px-5 py-2 xl:py-2.5 mr-2 hover:bg-amazone-orange focus:outline-none"
  data-tooltip-target="tooltip-feedback-and-support"
  data-tooltip-placement="right"
>
  <!-- <app-add></app-add> -->
  Support
</a>
<div
  id="tooltip-feedback-and-support"
  role="tooltip"
  class="absolute z-10 invisible inline-block px-3 py-2 text-sm font-medium text-white transition-opacity duration-300 bg-amber-600 rounded-lg shadow-xs opacity-0 tooltip"
>
  Feedback? Found a bug? Any Questions? Contact Team-AEDBIS!
  <div class="tooltip-arrow" data-popper-arrow></div>
</div>
